/** Uncaught browser errors are POSTed to the API's client-errors endpoint, which drops them into the
 * same OpenTelemetry pipeline as server errors (anonymous, rate limited, nothing stored).
 * Reports are deduped so a render loop cannot spam the endpoint. */
import { API_BASE } from "../api/client";

type Kind = "error" | "unhandledrejection" | "render";

const sent = new Set<string>();

export function reportError(kind: Kind, error: unknown) {
  const err = error instanceof Error ? error : new Error(String(error));
  const key = `${kind}:${err.message}`;
  if (sent.has(key)) return;
  sent.add(key);
  fetch(`${API_BASE}/client-errors`, {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
    headers: { "Content-Type": "application/json", "X-Requested-With": "learn" },
    body: JSON.stringify({
      kind,
      message: err.message.slice(0, 500),
      stack: (err.stack ?? "").slice(0, 4000),
      path: window.location.pathname,
      release: "",
    }),
  }).catch(() => {
    /* reporting must never break the page */
  });
}

export function installErrorReporting() {
  window.addEventListener("error", (e) => reportError("error", e.error ?? e.message));
  window.addEventListener("unhandledrejection", (e) => reportError("unhandledrejection", e.reason));
}
